import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '@exchange/environment'

export interface IProcessingProgressField {
  name: string
  value: string
}

export interface IProcessingProgressStep {
  stepName: string
  orderIndex: number
  status: string
  shortMessage: string
  message: string
  timestamp: string
  pipelineType: string
  fields: IProcessingProgressField[]
}

export interface IProcessingProgressResponse {
  steps: IProcessingProgressStep[]
}

export interface IProcessingProgressRow {
  StepName: string
  OrderIndex: number
  Status: string
  ShortMessage: string
  Message: string
  Timestamp: string
  PipelineType: string
  FieldName: string
  FieldValue: string
}

@Injectable()
export class ProcessingProgressService {
  constructor(private http: HttpClient) {}
  baseUri = `${environment.tmapiroot}/Views/ProcessingProgress`

  getProgressSteps(claimId: number, serviceId: number): Observable<IProcessingProgressStep[]> {
    return this.http
      .get<IProcessingProgressResponse>(`${this.baseUri}?claimId=${claimId}&serviceId=${serviceId}`)
      .pipe(
        map(response => 
          (response.steps || []).sort((a, b) => {
            const aIsClaim = a.pipelineType === 'Claim' ? 1 : 0
            const bIsClaim = b.pipelineType === 'Claim' ? 1 : 0
            return aIsClaim - bIsClaim || a.orderIndex - b.orderIndex
          })
        )
      )
  }

  getProgress(claimId: number, serviceId: number): Observable<IProcessingProgressRow[]> {
    return this.http
      .get<IProcessingProgressResponse>(`${this.baseUri}?claimId=${claimId}&serviceId=${serviceId}`)
      .pipe(
        map(response =>
          (response.steps || []).flatMap(step =>
            step.fields.length > 0
              ? step.fields.map(f => ({
                  StepName: step.stepName,
                  OrderIndex: step.orderIndex,
                  Status: step.status,
                  ShortMessage: step.shortMessage,
                  Message: step.message,
                  Timestamp: step.timestamp,
                  PipelineType: step.pipelineType,
                  FieldName: f.name,
                  FieldValue: f.value
                }))
              : [
                  {
                    StepName: step.stepName,
                    OrderIndex: step.orderIndex,
                    Status: step.status,
                    ShortMessage: step.shortMessage,
                    Message: step.message,
                    Timestamp: step.timestamp,
                    PipelineType: step.pipelineType,
                    FieldName: '',
                    FieldValue: ''
                  }
                ]
          )
        )
      )
  }
}
